import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-1_2",
  "use": "icon-1_2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-1_2\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M15.89,0H8.11C7.5,0,7,.9,7,2V22c0,1.1.5,2,1.11,2h7.78c.61,0,1.11-.9,1.11-2V2C17,.9,16.5,0,15.89,0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol